import Vue from 'vue';

const ToastEvent = new Vue({
  methods: {
    emitGlobalError(message, dismiss, timeout = 6000) {
      this.$emit('globalToast', 'clear', message, dismiss, timeout);
    },
    emitGlobalSuccess(message, dismiss, timeout = 6000) {
      this.$emit('globalToast', 'done_all', message, dismiss, timeout);
    },
    emitGlobalInformation(message, dismiss, timeout = 6000) {
      this.$emit('globalToast', 'info', message, dismiss, timeout);
    },
  },
});

export default ToastEvent;
